module.exports = __webpack_public_path__ + "img/interational_air_img_1.b203f68b.png";